import * as React from "react";
import { Alert } from "@grandvisionhq/iris-ui";
import { useIntl } from "@grandvisionhq/state";
import { useErrorMessageContext } from "../../../../context/ErrorMessageContext/context/ErrorMessageContext/context.js";
const ErrorMessagesContainer = () => {
  const [, { errors }] = useErrorMessageContext();
  const { getLabel } = useIntl();
  return /* @__PURE__ */ React.createElement(React.Fragment, null, errors.map((labels) => /* @__PURE__ */ React.createElement(
    Alert,
    {
      key: labels.title,
      variant: labels.type,
      title: getLabel(labels.title),
      className: "alert-m-default"
    },
    labels.message && getLabel(labels.message)
  )));
};
export {
  ErrorMessagesContainer as default
};
//# sourceMappingURL=ErrorMessagesContainer.js.map
